import Axios from "axios";

class GeoServerOws {
	static get = (url) => {
		return Axios
			.get(url)
			.then(response => {
				return response.data;
			});
	};
}

export default GeoServerOws;